import _ from 'lodash';
import React, {Component} from 'react';
import styles from './EditBoxStyles';
import Radium from 'radium';
import {KNOB_DIRECTIONS} from 'crazyEditor/core/constants/editorConstants';
import {getElementDefinitionProps, getElementMethods} from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {getElementStageLayout, getElementsBoundingLayout} from '../MouseCatcherUtils';
import {connect} from 'react-redux';
import TextEditBox from './TextEditBox';
import {updateDesktopElement} from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import ResizeKnobs from './ResizeKnobs/ResizeKnobs';
import {editDesktopElement} from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import {zIndexMouseCatcher} from 'crazyEditor/core/globals';
import {getSelectedElementsWithDragPosition, isMultiSelect} from 'crazyEditor/redux/modules/element/elementSelectors';
import shallowEqual from 'fbjs/lib/shallowEqual';
import {THUMBNAIL_ROW_TRANSITION_DURATION} from 'crazyEditor/core/constants/editorConstants';
const classes = require('shared/styles/common.scss');

@connect(
  state => ({
    selectedElements: getSelectedElementsWithDragPosition(state),
    isDraggingElement: state.stage.isDraggingElement,
    isMultiSelect: isMultiSelect(state),
    isDesktopView: state.editor.isDesktopView,
    stageLayout: state.stage.layout,
  }),
  {updateDesktopElement},
  false,
  {forwardRef: true}
)
export default class EditBox extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
  }

  getEditBoxStyles(element, draggable, boundingLayout) {
    const elementStageLayout = getElementStageLayout(element, boundingLayout);
    let heightConstraint;
    if (getElementDefinitionProps(element).autoHeight) {
      heightConstraint = {minHeight: elementStageLayout.height};
    } else {
      heightConstraint = {height: elementStageLayout.height};
    }
    return {
      ...styles.editBox,
      cursor: draggable ? 'move' : null,
      ..._.omit(elementStageLayout, 'height'),
      ...heightConstraint,
    };
  }

  isResizable(element, resizable) {
    return !element.locked && resizable;
  }

  shouldRenderEditBox(selectedElements) {
    if (selectedElements.length) {
      const elementDefinitionProps = getElementDefinitionProps(selectedElements[0]);
      return elementDefinitionProps.selectable;
    }
    return false;
  }

  renderEditBox(element, boundingLayout) {
    const renderTextEditBox = element.editingTextElement;
    const {isMultiSelect, isDraggingElement, updateDesktopElement, isDesktopView} = this.props;
    const elementDefinitionProps = getElementDefinitionProps(element);
    const elementMethods = getElementMethods(element.type);
    const {draggable, resizable, isTextElement} = elementDefinitionProps;
    return (
      <div
        className={renderTextEditBox ? undefined : classes.noSelect}
        style={this.getEditBoxStyles(element, draggable, boundingLayout)}
        key={`editBox${element.id}`}
        onClick={isMultiSelect || isDraggingElement ? _.noop : this.onClick}
        onDoubleClick={
          isMultiSelect || isDraggingElement || !isDesktopView ? _.noop : () => editDesktopElement(element)
        }
        draggable={false}
      >
        {renderTextEditBox && isTextElement && (
          <TextEditBox
            ref={ref => {
              if (ref) this.textEditBoxRef = ref;
            }}
            element={element}
            onChange={html => {
              updateDesktopElement(element.id, elementMethods.getTextSetter(html), element.data.templateTag);
            }}
          />
        )}
        {!isMultiSelect && this.isResizable(element, resizable) && <ResizeKnobs knobs={resizable} />}
        {elementMethods.getInteractiveElements &&
          _.map(elementMethods.getInteractiveElements(element.id), (interactiveElement, index) => {
            return (
              <div
                key={index}
                style={interactiveElement.style}
                onClick={() => {
                  interactiveElement.element.click();
                  if (elementMethods.refreshInteractiveElementsList) {
                    elementMethods.refreshInteractiveElementsList(element.id, () => {
                      this.forceUpdate();
                    });
                  }
                }}
              />
            );
          })}
      </div>
    );
  }

  renderMultiSelectBoundingBox(elements) {
    const boundingLayout = getElementsBoundingLayout(elements);
    return (
      <div
        className={classes.noSelect}
        style={{...styles.multiSelectBoundingBox, ...boundingLayout, ...this.multiSelectBoundingBoxAdditionalStyle}}
      >
        {_.map(elements, element => this.renderEditBox(element, boundingLayout))}
        <ResizeKnobs knobs={_.values(KNOB_DIRECTIONS)} />
      </div>
    );
  }

  render() {
    const {selectedElements, isMultiSelect} = this.props;
    if (!this.shouldRenderEditBox(selectedElements)) {
      return null;
    }
    return (
      <div>
        {!isMultiSelect && this.renderEditBox(selectedElements[0])}
        {isMultiSelect && this.renderMultiSelectBoundingBox(selectedElements)}
      </div>
    );
  }
}
